module.exports = require('./helpers/bundle-url').getBundleURL('aSzjM') + "logo-dark.eefe0b7f.svg";